import {  COOKIE_RESPONSIBLE_URL } from './constants'

export const getShouldRedirectFromCookies = () => {
  const r = document.cookie.match(`\\b${COOKIE_RESPONSIBLE_URL}=([^;]*)\\b`)
  return r ? r[1] : undefined
}

export const clearShouldRedirectFromCookies = () => {
  document.cookie = `${COOKIE_RESPONSIBLE_URL}="";path=/;domain=.plurall.net;expires=Thu, 01 Jan 1970 00:00:00 GMT`
}
